import React from "react"
import "./styles/Brand.css"

const Brand: React.FC<React.HTMLAttributes<HTMLDivElement> & {image?: string, title?: string}> = (props) => {

    return <div className={`AmoTools__Brand ${props.className ?? ""}`}>

        {props.image && <img
            className="AmoTools__Brand__Image"
            src={props.image}
            alt={props.title}
        />}
        <span
            className="AmoTools__Brand__Title">
            {props.title}
        </span>
    </div>

}

export default Brand
